export enum AccountRenewalAction {
  AUTO_RENEW = 'AUTO_RENEW',
  AUTO_QUOTE = 'AUTO_QUOTE',
  NONE = 'NONE',
  UNKNOWN = 'UNKNOWN',
}
